import { actionTypes } from '../../constants';
import { GET_SWEEPS_LIST_ENDPOINT, SWEEPS_EDIT_DELETE_ENDPOINT } from '../../constants/urls';
import { RSAA } from 'redux-api-middleware';
const {
  GET_SWEEP_LIST,
  GET_SWEEP_LIST_SUCCESS,
  GET_SWEEP_LIST_FAILURE,
  GET_SWEEP_ALERT,
  GET_SWEEP_ALERT_SUCCESS,
  GET_SWEEP_ALERT_FAILURE,
  UPDATE_SWEEP_ALERT,
  UPDATE_SWEEP_ALERT_SUCCESS,
  UPDATE_SWEEP_ALERT_FAILURE,
  DELETE_SWEEP_ALERT,
  DELETE_SWEEP_ALERT_SUCCESS,
  DELETE_SWEEP_ALERT_FAILURE,
} = actionTypes;
import { X_BPI_VERSION_0_9_0 } from '../../constants/VersionConstants';

export const getSweepsList = (accountId) => ({
  [RSAA]: {
    endpoint: GET_SWEEPS_LIST_ENDPOINT.replace('accountId', accountId),
    method: 'GET',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_9_0,
    },
    types: [GET_SWEEP_LIST, GET_SWEEP_LIST_SUCCESS, GET_SWEEP_LIST_FAILURE],
  },
});
export const updateSweepAlerts = (reqBody, accountId, sweepId) => ({
  [RSAA]: {
    endpoint: SWEEPS_EDIT_DELETE_ENDPOINT.replace('accountId', accountId).replace(
      'sweepId',
      sweepId
    ),
    method: 'PUT',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_9_0,
    },
    body: JSON.stringify(reqBody),
    types: [
      { type: UPDATE_SWEEP_ALERT },
      { type: UPDATE_SWEEP_ALERT_SUCCESS },
      {
        type: UPDATE_SWEEP_ALERT_FAILURE,
        meta: { category: 'PUT', sweepPacket: reqBody },
      },
    ],
  },
});
export const getSweepsAlerts = (reqBody, accountId) => ({
  [RSAA]: {
    endpoint: GET_SWEEPS_LIST_ENDPOINT.replace('accountId', accountId),
    method: 'POST',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_9_0,
    },
    body: JSON.stringify(reqBody),
    types: [
      { type: GET_SWEEP_ALERT },
      { type: GET_SWEEP_ALERT_SUCCESS },
      {
        type: GET_SWEEP_ALERT_FAILURE,
        meta: { category: 'POST', sweepPacket: reqBody },
      },
    ],
  },
});
export const deleteSweepAlerts = (accountId, sweepId) => ({
  [RSAA]: {
    endpoint: SWEEPS_EDIT_DELETE_ENDPOINT.replace('accountId', accountId).replace(
      'sweepId',
      sweepId
    ),
    method: 'DELETE',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_9_0,
    },
    types: [
      { type: DELETE_SWEEP_ALERT },
      { type: DELETE_SWEEP_ALERT_SUCCESS },
      {
        type: DELETE_SWEEP_ALERT_FAILURE,
        meta: { category: 'DELETE' },
      },
    ],
  },
});
